import { IDeductionAttachDocumentsParams, IDeductionAttachDocumentsResponse } from "@/core/repositories/deduction";
import { DeductionRepository } from "@/infrastructure/repositories/deduction/Deduction.repository";

class AttachDeductionDocumentsUseCase {
  constructor(private readonly deductionRepository: DeductionRepository) {}

  async execute(attachDocumentsRequest: IDeductionAttachDocumentsParams, currentPage: number): Promise<IDeductionAttachDocumentsResponse> {
    return this.deductionRepository.attachDocumentsToDeduction(attachDocumentsRequest, currentPage);
  }
}

export default AttachDeductionDocumentsUseCase;
